import { Badge } from "@alight/ui";
import { TOPIC_LABELS, type MessageStatus, type MessageTopic } from "../lib/api";

/** Small presentational pieces shared by the admin inbox and detail views. */

/** The form's topic. Expressions of interest get the accent so they stand
 *  out in the list — they are the messages that turn into grads at the door. */
export function TopicBadge({ topic }: { topic: MessageTopic }) {
  const label = TOPIC_LABELS[topic] ?? topic;
  if (topic === "eoi") return <Badge variant="accent">{label}</Badge>;
  return <Badge variant="default">{label}</Badge>;
}

export function StatusBadge({ status }: { status: MessageStatus }) {
  switch (status) {
    case "new":
      return <Badge variant="accent">New</Badge>;
    case "replied":
      return <Badge variant="success">Replied</Badge>;
    case "archived":
      return <Badge variant="muted">Archived</Badge>;
  }
}

/** D1/SQLite timestamps arrive as "YYYY-MM-DD HH:MM:SS" (UTC, no T/Z) —
 *  normalise those so they render in the operator's local time. */
function parseDate(iso: string): Date {
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(iso)) {
    return new Date(`${iso.replace(" ", "T")}Z`);
  }
  return new Date(iso);
}

export function formatDate(iso: string): string {
  const d = parseDate(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Date only — keeps list rows narrow; exact time shows on the detail page. */
export function formatDay(iso: string): string {
  const d = parseDate(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}
